
import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

interface PortfolioHeaderProps {
  handleBack?: () => void;
}

const PortfolioHeader = ({ handleBack }: PortfolioHeaderProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  
  const handleBackClick = () => {
    if (handleBack) {
      handleBack();
    } else {
      navigate(-1);
    }
  };
  
  return (
    <header className="w-full py-4 flex items-center justify-between">
      {!isMobile ? (
        <div className="flex items-center gap-4">
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleBackClick} 
            className="flex items-center text-gray-600 hover:text-gray-900"
          >
            <ChevronLeft size={16} />
            Back
          </Button>
          <h1 className="text-xl font-semibold">Portfolio Settings</h1>
        </div>
      ) : (
        <div className="flex justify-between w-full">
          <h1 className="text-xl font-semibold md:mx-[20px] mx-0">Portfolio Settings</h1>
          
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleBackClick} 
            className="flex items-center text-gray-600 hover:text-gray-900 md:mx-[20px] mx-0"
          >
            <ChevronLeft size={16} />
            Back
          </Button>
        </div>
      )}
    </header>
  );
};

export default PortfolioHeader;
